'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';

interface DuplicateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending?: boolean;
}

export function DuplicateDialog({ open, onOpenChange, onConfirm, isPending = false }: DuplicateDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-border/60 bg-card shadow-xl ring-2 ring-border/20 dark:border-border/80 dark:ring-border/30">
        <AlertDialogHeader className="space-y-3">
          <AlertDialogTitle className="text-xl font-semibold leading-tight text-foreground sm:text-2xl">
            Dupliquer l'inventaire
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm leading-relaxed text-muted-foreground/90 sm:text-base dark:text-muted-foreground/80">
            Êtes-vous sûr de vouloir dupliquer cet inventaire ? Une copie complète sera créée avec un nouvel arbre.
            Vous pourrez ensuite choisir la nouvelle position sur la carte.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-3 sm:gap-2.5">
          <AlertDialogCancel className="h-10 border-border/60 bg-background px-4 text-sm font-semibold transition-all duration-200 hover:border-border hover:bg-accent/80 dark:border-border/80 dark:hover:bg-accent/60">
            Annuler
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="h-10 bg-primary px-4 text-sm font-semibold text-primary-foreground shadow-md transition-all duration-200 hover:bg-primary hover:shadow-lg disabled:opacity-50 dark:bg-primary dark:hover:bg-primary"
            disabled={isPending}
          >
            {isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
                Duplication...
              </>
            ) : (
              'Dupliquer'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

